import Vue from "vue";
import PictureUploader from "../../components/PictureUploader.vue";
import AccountStatusToggle from "../../components/AccountStatusToggle.vue";

export const PageComponent = Vue.extend({
  components: {
    PictureUploader,
    AccountStatusToggle
  }
});
